module.exports = __webpack_public_path__ + "static/media/coins.2c034d6f.svg";